import { Ref } from 'vue';
import { dropdownField } from '@/ui/components/form';
import { updateMultiple } from '@/ui/queryState';
import { PaginationResetCallback, SelectOptions } from '@/ui/types';

export const dropdownFilter = <T>({
  value,
  name,
  label,
  placeholder,
  options,
  reset,
  hideLabel,
  horizontal,
}: {
  value: Ref<T>;
  name: string;
  label: string;
  placeholder: string;
  options: SelectOptions<T>;
  reset: PaginationResetCallback;
  hideLabel?: boolean;
  horizontal?: boolean;
}) => dropdownField<T>(
  {
    value: value.value,
    name,
    label,
    placeholder,
    options,
    required: false,
    errors: [],
    disabled: false,
    hideLabel,
    horizontal,
  },

  v => updateMultiple(() => {
    reset();
    value.value = v;
  }, true),
);
